import { getAppInstance } from '@/utils/api/app';

export const postClientTags = (applicationId: string, clickId: string) =>
  getAppInstance().post(`/client-tags/${applicationId}`, { clickId });
